import * as monaco from 'monaco-editor';

export const defineCustomTheme = (monacoInstance: typeof monaco, darkMode: boolean) => {
    const themeName = 'custom-slider-theme';

    monacoInstance.editor.defineTheme(themeName, {
        base: darkMode ? 'vs-dark' : 'vs',
        inherit: true,
        rules: [],
        colors: {
            'scrollbarSlider.background': 'var(--tw-primary)',
            'scrollbarSlider.hoverBackground': 'var(--tw-primary)',
            'scrollbarSlider.activeBackground': 'var(--tw-primary)',
            'minimapSlider.background': 'var(--tw-primary-light)',
            'minimapSlider.hoverBackground': 'var(--tw-primary)',
            'minimapSlider.activeBackground': 'var(--tw-primary)',
        },
    });

    monacoInstance.editor.setTheme(themeName);
    return themeName;
};


export const handleEditorDidMount = (editor: any, monacoInstance: typeof monaco) => {
    monacoInstance.editor.setTheme('custom-slider-theme');

    // Inject slim scrollbar styling
    const style = document.createElement('style');
    style.innerHTML = `.monaco-scrollable-element > .scrollbar.vertical { width: 6px !important;} .minimap-slider-horizontal { background-color: var(--tw-primary-light)  !important;opacity: 1 !important;}.minimap-slider {  bottom: 0 !important;}.monaco-scrollable-element > .scrollbar.vertical .slider {  background-color:var(--tw-primary-clarity) !important;  border-radius: 0px !important;  opacity: 1 !important;}.monaco-scrollable-element > .scrollbar.horizontal {  height: 6px !important;}.monaco-scrollable-element .decorationsOverviewRuler {  width: 8px !important;}.monaco-scrollable-element > .scrollbar.horizontal .slider {  background-color:var(--tw-primary-clarity) !important;  border-radius: 0px !important;  opacity: 1 !important;} `;
    document.head.appendChild(style);
};

